// components/AccessGate.jsx
import { useAccess } from "../utils/UseAccess";

export function AccessGate({ role: requiredRole, fallback = null, loading = null, children }) {
  const { can, isAuthReady } = useAccess();

  if (!isAuthReady) return loading;
  return can(requiredRole) ? children : fallback;
}